/* ==========================================================================
   tl-boxer.js — Tokyo Lifestyle · Boxer Combo landing
   --------------------------------------------------------------------------
   Runs the four-slot combo builder, the EN/বাংলা switch, the theme switch and
   the scroll choreography on /pages/boxer-combo.

   Forked from tl-combo.js (the track pant funnel). Element ids, classes and
   localStorage keys all use the `tlx-` prefix so the two pages share nothing
   but their lineage.

   Compatibility note: this page's traffic is overwhelmingly Android inside the
   Facebook / Instagram in-app browser, so the code deliberately stays inside
   ES2015 — no optional chaining, no nullish coalescing, no object spread, no
   Array.prototype.flat. IntersectionObserver and fetch are feature-detected.

   Pricing note: `boxer-combo` is NO LONGER a flat-price collection. It holds
   ৳890 cotton-stretch packs and a ৳990 microfiber pack, so the total depends
   on the mix and a fixed ladder cannot express it.

   ONE automatic discount is scoped to the collection, "Boxer Combo - Buy 3
   Get 1 Free". Shopify frees the CHEAPEST eligible line, and the offer needs
   four items to trigger, so:

       count < 4  →  no discount at all
       count = 4  →  subtotal minus the cheapest pack in the basket

   which yields ৳2670 for four ৳890 packs, ৳2770 for three ৳890 plus one ৳990,
   and ৳2970 for four ৳990. Verified against real carts at
   tokyolifestyle.online. LADDER is kept ONLY as the all-৳890 headline the
   marketing copy quotes; it is never used to bill anyone.

   This file previously carried a flat-price engine and the `cheapest-free`
   mode was deleted as dead code. Adding the ৳990 pack brought it back — with
   the flat engine the page quoted ৳2670 while checkout charged ৳2770.
   (Both figures re-measured against a real cart 2026-10-08; this note said
   ৳2760 until then — 3,660 less the free ৳890 is 2,770.)
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('tlx-root');
  var dataEl = document.getElementById('tlx-data');
  if (!root || !dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var SLOTS = DATA.slots || 4;
  var UNIT = DATA.unit || 950;
  var LADDER = DATA.ladder || { 1: 890, 2: 1780, 3: 2670, 4: 2670 };
  /* Buy N-1 Get 1 Free fires at N items. */
  var FREE_AT = DATA.slots || 4;
  var PER_PACK = DATA.perPack || 3;
  var DELIVERY = DATA.delivery || { inside: 70, outside: 130 };
  var STYLES = DATA.styles || [];
  var SIZE_CHART = DATA.sizeChart || [];
  var AUTOPLAY = DATA.autoplay !== false;
  var AUTOPLAY_MS = (DATA.autoplaySec || 4) * 1000;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Copy ───────────────────────────────────────────────────────────────
     Every visible string lives here so the two languages can never drift.
     Keys are referenced from the markup via data-i18n / data-i18n-html.     */
  var BN = {
    'nav.offer': 'অফার',
    'nav.styles': 'প্যাক',
    'nav.sizing': 'সাইজ',
    'nav.faq': 'প্রশ্ন',
    'nav.order': 'অর্ডার করুন',
    'nav.themeLabel': 'থিম বদলান',

    'tape.cod': 'সারা বাংলাদেশে ক্যাশ অন ডেলিভারি',
    'tape.product': 'কটন স্ট্রেচ বক্সার ব্রিফ · প্রতি বক্সে ৩টি',
    'tape.colours': 'নেভি · ব্ল্যাক · গ্রে · হোয়াইট',
    'tape.offer': '৩ প্যাক কিনলে ১ প্যাক ফ্রি — ৳২৬৭০',
    'tape.flat': '১২টি বক্সার · প্রতিটি ৳২২৩',
    'tape.stock': 'এস থেকে ডাবল-এক্সএল স্টকে আছে',

    /* Deliberately the generic wording: the English badge can also render a
       measured "stock for N more" variant, and the dictionary cannot know N.
       Falling back to the generic line is correct — it is never a claim the
       stock does not support. */
    'hero.badge': 'সীমিত কম্বো · স্টক থাকা পর্যন্ত',
    'hero.title1': 'চারটি প্যাক নিন।',
    'hero.title2': 'তিনটির দাম দিন।',
    'hero.tape': '<b>৳২৬৭০</b> থেকে ১২টি বক্সার — সেভ ৳৮৯০+',
    'hero.lead':
      'কটন-ব্লেন্ড স্ট্রেচ বক্সার ব্রিফ — প্রতি বক্সে ৩টি, কনটুর পাউচ, মিড-থাই লেংথ যা উঠে যায় না। প্রতি প্যাক ৳৮৯০ থেকে। ৪টি নিলে ৪র্থটি ফ্রি, অর্থাৎ ১২টি বক্সার পড়ছে প্রতিটি ৳২২৩ করে।',
    'hero.cta1': 'কম্বো সাজান',
    'hero.cta2': 'প্যাকগুলো দেখুন',
    'hero.stat1k': 'প্রতি বক্সার',
    'hero.stat2v': '১২টি বক্সার',
    'hero.stat2k': '৳২৬৭০-এ',
    'hero.stat3k': 'সাইজ স্টকে',
    'hero.railk': 'যেকোনো ৪টি মিলিয়ে নিন',
    'hero.floatOffer': '৩ প্যাক কিনুন → <em>১টি ফ্রি</em>',
    'hero.floatK': '১২টি বক্সার',

    'ladder.eyebrow': 'অফার',
    'ladder.h2': '৩টি প্যাক কিনুন, ৪র্থটি ফ্রি।',
    'ladder.lead':
      'প্যাক শুরু ৳৮৯০ থেকে। যেকোনো ৪টি নিন — সবচেয়ে কম দামেরটি ফ্রি, চেকআউটে নিজে থেকেই বসে যায়, কোনো কুপন কোড লাগে না।',
    'ladder.t1q': '১ প্যাক',
    'ladder.t2q': '২ প্যাক',
    'ladder.t3q': '৩ প্যাক',
    'ladder.t4q': '৪ প্যাক',
    'ladder.pieces': 'টি বক্সার',
    'ladder.save': 'সেভ',
    'ladder.best': 'সেরা ডিল',
    'ladder.pick': 'এটাই নিন',
    'ladder.kicker': 'আপনার ৪র্থ প্যাকটি <b>ফ্রি</b> — ৩ প্যাকের দামেই ৪ প্যাক।',

    'build.eyebrow': 'কম্বো সাজান',
    'build.h2': 'আপনার ৪টি প্যাক বাছুন',
    'build.note':
      'একটি স্লটে ট্যাপ করুন, প্যাক বাছুন, সাইজ বাছুন। যেভাবে খুশি মেলাতে পারেন — চারটিই এক সাইজ, বা প্রতিটি স্লটে আলাদা সাইজ। ডিসকাউন্ট চেকআউটে নিজে থেকেই বসে যাবে।',
    'build.slotEmpty': 'প্যাক বাছুন',
    'build.slotFree': 'এই প্যাকটি ফ্রি',
    'build.free': 'ফ্রি',
    'build.remove': 'সরিয়ে দিন',
    'build.ready': '{n} প্যাক · {p} — চেকআউট করতে পারেন',
    'build.nudge0': 'প্রথম প্যাকটি বেছে নিন — {u}',
    'build.nudgeMore': 'আরও ১টি নিলে {n} প্যাক {next}',
    'build.nudgeLastFree':
      'শেষ প্যাকটি <b>একদম ফ্রি</b> — যোগ করলে দাম এক টাকাও বাড়বে না। মোট সেভ <b>{save}</b>',
    'build.nudgeLastPaid':
      'শেষ প্যাকটি যোগ করুন মাত্র <b>{step}</b> বেশি দিয়ে — মোট সেভ <b>{save}</b>',
    'build.nudgeDone': '{t}টি প্যাকই বাছা হয়েছে — আপনি সেভ করছেন {save}',

    'sum.h': 'আপনার কম্বো',
    'sum.count': 'প্যাক',
    'sum.empty': 'এখনো কোনো প্যাক বাছা হয়নি।',
    'sum.areaK': 'ডেলিভারি এলাকা',
    'sum.inside': 'ঢাকার ভেতরে',
    'sum.outside': 'ঢাকার বাইরে',
    'sum.subtotal': 'প্যাকের দাম',
    'sum.saving': 'কম্বো সেভিং',
    'sum.delivery': 'ডেলিভারি',
    'sum.total': 'সর্বমোট',
    'sum.cta': 'কার্টে দিয়ে চেকআউট করুন',
    'sum.ctaWait': 'আরও প্যাক বাছুন',
    'sum.adding': 'যোগ করা হচ্ছে…',
    'sum.trust1': 'সারা বাংলাদেশে ক্যাশ অন ডেলিভারি',
    'sum.trust2': '৭ দিনের মধ্যে সাইজ বদলানো যাবে',
    'sum.trust3': 'ঢাকার ভেতরে ১–৩ দিনে ডেলিভারি',
    'sum.err': 'কিছু একটা ভুল হয়েছে। আরেকবার চেষ্টা করুন।',
    'sum.errStock': 'দুঃখিত, এই সাইজে আর স্টক নেই। অন্য একটি বেছে নিন।',
    'sum.cartHas': 'আপনার কার্টে আগেই {n}টি অন্য পণ্য আছে — চেকআউটে সেগুলোও যোগ হবে।',
    'sum.ctaDetails': 'তথ্য দিয়ে অর্ডার করুন',

    'pick.h1': 'প্যাক বাছুন',
    'pick.h2': 'সাইজ বাছুন',
    'pick.step1': 'ধাপ ১ / ২',
    'pick.step2': 'ধাপ ২ / ২',
    'pick.close': 'বন্ধ করুন',
    'pick.back': 'প্যাকে ফিরে যান',
    'pick.left': 'প্যাক বাকি',
    'pick.out': 'স্টক শেষ',
    'pick.low': 'শেষ {n}টি',
    'pick.slot': 'স্লট {n}',
    'pick.chart': 'সাইজ চার্ট (কমরের মাপ)',
    'pick.chartHint': 'কমরের মাপ দেখে সাইজ বাছুন',

    'styles.eyebrow': 'প্যাকগুলো',
    'styles.h2': '৪টি প্যাক, শুরু ৳৮৯০ থেকে',
    'styles.lead':
      'প্রতিটি বক্সে ৩টি বক্সার ব্রিফ, এস থেকে ডাবল-এক্সএল। যেকোনো ৪টি নিন — একই প্যাক একই সাইজ, বা প্রতিটি স্লটে আলাদা।',
    'styles.view': 'পণ্যটি দেখুন',
    'styles.add': 'কম্বোতে যোগ করুন +',
    'styles.soldout': 'স্টক শেষ',
    'toast.soldout': 'এই প্যাকটির স্টক শেষ',
    'toast.full': 'চারটি স্লটই ভরা — বদলাতে একটি স্লটে ট্যাপ করুন',

    'spec.eyebrow': 'বক্সে যা যা আছে',
    'spec.h2': 'প্রতিদিনের আরাম, একসাথে ৩টি',
    'spec.t1': 'প্রতি বক্সে ৩টি',
    'spec.d1': 'প্রতিটি ৳৮৯০ প্যাকে ৩টি বক্সার ব্রিফ — একটি নয়।',
    'spec.t2': 'স্ট্রেচ ফ্যাব্রিক',
    'spec.d2': 'শরীরের সাথে সহজে নড়ে, টান লাগে না — বসা, হাঁটা বা জিম, সারাদিন।',
    'spec.t3': 'কনটুর পাউচ',
    'spec.d3': 'সামনে শেপ করা পাউচ — সাপোর্ট দেয়, সাধারণ চ্যাপ্টা প্যানেল নয়।',
    'spec.t4': 'নরম কটন-ব্লেন্ড',
    'spec.d4': 'কটন-ব্লেন্ড কাপড়, গায়ে নরম লাগে — প্রতিদিন পরার জন্য এটাই আসল কথা।',
    'spec.t5': 'মিড-থাই লেংথ',
    'spec.d5': 'মিড-থাই পর্যন্ত কাটা, তাই প্যান্টের নিচে উঠে যায় না।',
    'spec.t6': 'অফিস, ক্যাজুয়াল, অ্যাকটিভ',
    'spec.d6': 'প্রতিদিনের ব্যবহারের জন্য — অফিস, ভ্রমণ আর জিম, যেখানে ৩-প্যাক আসল কাজে লাগে।',

    'how.eyebrow': 'কীভাবে কাজ করে',
    'how.h2': '৳২৬৭০-এ পৌঁছানোর তিন ধাপ',
    'how.t1': '৪টি স্লট ভরুন',
    'how.d1': 'যেকোনো ৪টি প্যাক আর সাইজ বাছুন। চারটি একই হলেও চলবে।',
    'how.t2': 'চেকআউট করুন',
    'how.d2': 'ডিসকাউন্ট নিজে থেকেই বসে যাবে। নাম, ঠিকানা আর ফোন নম্বর দিন।',
    'how.t3': 'হাতে পেয়ে টাকা দিন',
    'how.d3': 'ক্যাশ অন ডেলিভারি সারা বাংলাদেশে। কুরিয়ারের হাতে টাকা দিন।',

    'size.eyebrow': 'সাইজ',
    'size.h2': 'আপনার সাইজ বের করুন',
    'size.thSize': 'সাইজ',
    'size.thWaist': 'কমর (ইঞ্চি)',
    'size.thWaistCm': 'কমর (সেমি)',
    'size.note':
      'ট্রাউজারের সাইজ নয়, কমরের মাপ দেখে সাইজ বাছুন। প্যাকগুলোর নিজস্ব পেজে চার্ট সামান্য আলাদা, তাই উপরের প্রতিটি সারি দুটোই কভার করে — দুই সাইজের ঠিক মাঝামাঝি হলে বড়টি নিন।',

    'faq.eyebrow': 'প্রশ্ন-উত্তর',
    'faq.h2': 'যা জিজ্ঞেস করা হয়',
    'faq.q1': 'প্রতিটি স্লটে কি আলাদা সাইজ নিতে পারি?',
    'faq.a1':
      'পারবেন। প্রতিটি স্লটে আলাদা প্যাক আর আলাদা সাইজ নিতে পারেন — অথবা চারটিই একই। দাম দুই ক্ষেত্রেই ৳২৬৭০, তাই পুরো পরিবারের জন্য একসাথে নেওয়া যায়।',
    'faq.q2': 'ডিসকাউন্ট পেতে কোনো কুপন কোড লাগবে?',
    'faq.a2':
      'না। ডিসকাউন্টটি অটোমেটিক — কার্টে ৪টি প্যাক থাকলেই চেকআউটে ৳৮৯০ কমে যাবে।',
    'faq.q3': 'ডেলিভারি চার্জ কত?',
    'faq.a3': 'ঢাকার ভেতরে ৳৭০, ঢাকার বাইরে ৳১৩০। ক্যাশ অন ডেলিভারি সারা বাংলাদেশে।',
    'faq.q4': 'সাইজ না মিললে কী হবে?',
    'faq.a4':
      'পণ্য হাতে পাওয়ার ৭ দিনের মধ্যে সাইজ বদলে নিতে পারবেন, যদি ট্যাগ লাগানো থাকে আর পণ্যটি না-পরা অবস্থায় থাকে।',
    'faq.q5': 'কতদিনে পৌঁছাবে?',
    'faq.a5': 'ঢাকার ভেতরে সাধারণত ১–৩ দিন, ঢাকার বাইরে ২–৫ দিন।',
    'faq.q6': 'অফারটি কতদিন থাকবে?',
    'faq.a6':
      'স্টক থাকা পর্যন্ত। এটি ৩টি প্যাক নিয়ে তৈরি একটি সীমিত কম্বো — কোনো সাইজ শেষ হলে সেটি সাথে সাথেই এই পেজ থেকে সরে যায়।',

    'close.t1': 'চারটি প্যাক নিন।',
    'close.t2': 'তিনটির দাম দিন।',
    'close.d':
      '৳২৬৭০-এ ১২টি কটন স্ট্রেচ বক্সার ব্রিফ — প্রতিটি ৳২২৩। সারা বাংলাদেশে ক্যাশ অন ডেলিভারি।',
    'close.cta': 'কম্বো সাজান',

    'foot.shopH': 'শপ',
    'foot.helpH': 'সহায়তা',
    'foot.aboutH': 'টোকিও লাইফস্টাইল',
    'foot.combo': 'বক্সার কম্বো অফার',
    'foot.allTrack': 'সব বক্সার ও ব্রিফ',
    'foot.allProducts': 'সব পণ্য',
    'foot.sizeGuide': 'সাইজ গাইড',
    'foot.contact': 'যোগাযোগ',
    'foot.track': 'অর্ডার ট্র্যাক করুন',
    'foot.rights': 'সর্বস্বত্ব সংরক্ষিত।',
    'foot.tagline': 'বাংলাদেশে প্রিমিয়াম ফ্যাশন ও স্পোর্টসওয়্যার।',

    'dock.k': 'সর্বমোট',
    'dock.cta': 'চেকআউট',
    'dock.pick': 'কম্বো সাজান',
    'fcart.empty': 'কম্বো সাজান',
    'fcart.of': '{t}টির মধ্যে {n}টি বাছা হয়েছে',
    'fcart.ready': 'চেকআউট করতে পারেন',
    'fcart.save': 'সেভ {p}',

    'det.h': 'আপনার তথ্য',
    'det.step': 'ধাপ ২ / ২',
    'det.name': 'পুরো নাম',
    'det.phone': 'মোবাইল নম্বর',
    'det.address': 'পুরো ঠিকানা',
    'det.city': 'শহর / জেলা',
    'det.email': 'ইমেইল <em>(না দিলেও চলবে)</em>',
    'det.note':
      'পরের ধাপে শপিফাইয়ের নিরাপদ চেকআউট — আপনার তথ্য আগেই বসানো থাকবে। ক্যাশ অন ডেলিভারি, SSLCommerz বা বিকাশ বেছে নিয়ে অর্ডার নিশ্চিত করুন।',
    'det.errName': 'নাম লিখুন',
    'det.errPhone': 'সঠিক মোবাইল নম্বর দিন (যেমন ০১৭XXXXXXXX)',
    'det.errAddress': 'ঠিকানা লিখুন',
    'det.errCity': 'শহর বা জেলার নাম লিখুন',

    'toast.added': 'কার্টে যোগ হয়েছে — চেকআউটে যাচ্ছি…',
    'toast.removed': 'প্যাকটি সরিয়ে দেওয়া হয়েছে'
  };

  /* English copy for the strings the JS builds itself (slots, picker, summary,
     toasts). Everything that exists in the server-rendered markup is read out
     of the DOM instead — see readEnglish() — so page copy has exactly one
     home and the two halves cannot drift.

     Note the nudge strings carry {u} {n} {next} {step} {save} placeholders
     rather than literal taka figures. The parent file hard-codes them, which
     means editing a price in the section settings silently leaves the nudges
     quoting the old offer. Here every number is substituted from LADDER at
     render time, so the nudges cannot disagree with the ladder or the cart. */
  var EN_JS = {
    'build.slotEmpty': 'Choose a pack',
    'build.slotFree': 'This pack is free',
    'build.free': 'Free',
    'build.remove': 'Remove this pack',
    'build.ready': '{n} packs · {p} — ready to checkout',
    'build.nudge0': 'Pick your first pack — {u}',
    'build.nudgeMore': 'Add 1 more → {n} packs {next}',
    'build.nudgeLastFree':
      'Your last pack is <b>free</b> — adding it costs nothing. Total saving <b>{save}</b>',
    'build.nudgeLastPaid':
      'Add your last pack for just <b>{step}</b> more — total saving <b>{save}</b>',
    'build.nudgeDone': 'All {t} packs in — you save {save}',
    'sum.count': 'packs',
    'sum.empty': 'No packs chosen yet.',
    'sum.adding': 'Adding…',
    'sum.cta': 'Add to cart & checkout',
    'sum.ctaWait': 'Choose your packs',
    'sum.ctaDetails': 'Continue to payment',
    'sum.err': 'Something went wrong. Please try again.',
    'sum.errStock': 'Sorry, that size just sold out. Please pick another.',
    'sum.cartHas':
      'Your cart already has {n} other item(s) — those are added at checkout too.',
    'pick.h1': 'Choose a pack',
    'pick.h2': 'Choose a size',
    'pick.step1': 'Step 1 / 2',
    'pick.step2': 'Step 2 / 2',
    'pick.back': 'Back to packs',
    'pick.left': 'left',
    'pick.out': 'Sold out',
    'pick.low': 'Only {n} left',
    'pick.slot': 'Slot {n}',
    'pick.chart': 'Size chart (waist)',
    'pick.chartHint': 'Match your waist to pick the size',
    'ladder.pick': 'Choose this',
    'dock.cta': 'Checkout',
    'dock.pick': 'Build combo',
    'fcart.empty': 'Build your combo',
    'fcart.of': '{n} of {t} packs chosen',
    'fcart.ready': 'Ready to checkout',
    'fcart.save': 'save {p}',
    'det.h': 'Your details',
    'det.step': 'Step 2 of 2',
    'det.name': 'Full name',
    'det.phone': 'Mobile number',
    'det.address': 'Full address',
    'det.city': 'City / District',
    'det.email': 'Email <em>(optional)</em>',
    'det.note': "Next step is Shopify's secure checkout with your details already filled in — choose Cash on Delivery, SSLCommerz or bKash and confirm.",
    'det.errName': 'Please enter your name',
    'det.errPhone': 'Enter a valid mobile number (e.g. 01712345678)',
    'det.errAddress': 'Please enter your address',
    'det.errCity': 'Please enter your city or district',
    'styles.add': 'Add to combo +',
    'styles.soldout': 'Sold out',
    'toast.added': 'Added to cart — taking you to checkout…',
    'toast.removed': 'Pack removed',
    'toast.soldout': 'That pack is sold out',
    'toast.full': 'Every slot is full — tap a slot to change it'
  };

  var EN = {};

  var lang = 'en';
  var dict = EN;

  function T(key) {
    if (lang === 'bn' && BN[key] != null) return BN[key];
    return EN[key] != null ? EN[key] : '';
  }

  /* Capture the English copy straight out of the server-rendered markup so the
     page works with JS disabled and the dictionary has only one hand-written
     half to maintain. */
  function readEnglish() {
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var key = n.getAttribute('data-i18n') || n.getAttribute('data-i18n-html');
      if (key && EN[key] == null) {
        EN[key] = n.getAttribute('data-i18n-html') ? n.innerHTML : n.textContent;
      }
    }
  }

  function applyLang() {
    var html = document.documentElement;
    html.setAttribute('data-lang', lang);
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var htmlKey = n.getAttribute('data-i18n-html');
      var key = htmlKey || n.getAttribute('data-i18n');
      if (!key) continue;
      var val = T(key);
      if (!val) continue;
      if (htmlKey) n.innerHTML = val;
      else n.textContent = val;
    }
    var segs = root.querySelectorAll('[data-lang-btn]');
    for (var j = 0; j < segs.length; j++) {
      segs[j].setAttribute(
        'aria-pressed',
        segs[j].getAttribute('data-lang-btn') === lang ? 'true' : 'false'
      );
    }
    render();
  }

  function setLang(next) {
    lang = next === 'bn' ? 'bn' : 'en';
    try {
      localStorage.setItem('tlx-lang', lang);
    } catch (e) {}
    applyLang();
  }

  /* ── Money ─────────────────────────────────────────────────────────────── */
  var BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  function digits(str) {
    if (lang !== 'bn') return str;
    return String(str).replace(/[0-9]/g, function (d) {
      return BN_DIGITS[+d];
    });
  }

  function money(n) {
    var s = Math.round(n)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '৳' + digits(s);
  }

  /* ── Pricing ───────────────────────────────────────────────────────────── */
  /* Kept for the marketing ladder ONLY — the "4 packs ৳2670" cards, which
     quote the all-cheapest-pack case. Never used to compute a real bill.
     comboFor() below is what the visitor is actually charged. */
  function comboTotal(count) {
    if (count <= 0) return 0;
    if (LADDER[count] != null) return LADDER[count];
    return count * UNIT;
  }

  /* What Shopify will really charge for THIS basket.
     Buy 3 Get 1 Free needs four items to fire, and it discounts the cheapest
     eligible line — so below four there is no discount at all, and at four the
     cheapest pack in the basket comes off. Mirrors the live cart exactly. */
  function comboFor(prices) {
    var subtotal = 0;
    var cheapest = null;
    for (var i = 0; i < prices.length; i++) {
      subtotal += prices[i];
      if (cheapest === null || prices[i] < cheapest) cheapest = prices[i];
    }
    if (prices.length >= FREE_AT && cheapest !== null) return subtotal - cheapest;
    return subtotal;
  }

  /* Index of the slot the discount actually makes free — the CHEAPEST filled
     slot, not simply the last one, because Shopify discounts the cheapest
     eligible line. Every pack here is the same price so this resolves to the
     first filled slot, but the rule is kept rather than shortcut: if a pack at
     a different price is ever added to the collection, labelling the wrong
     slot "free" would misreport the bill. */
  function freeSlotIndex() {
    var count = 0;
    for (var i = 0; i < slots.length; i++) if (slots[i]) count++;
    if (count < SLOTS) return -1;
    var best = -1;
    var low = Infinity;
    for (var j = 0; j < slots.length; j++) {
      if (!slots[j]) continue;
      var pr = slots[j].price != null ? slots[j].price : UNIT;
      if (pr < low) {
        low = pr;
        best = j;
      }
    }
    return best;
  }

  function priceState() {
    var count = 0;
    var subtotal = 0;
    var prices = [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i]) continue;
      count++;
      var pp = slots[i].price != null ? slots[i].price : UNIT;
      subtotal += pp;
      prices.push(pp);
    }

    var total = count ? comboFor(prices) : 0;
    var ship = count ? DELIVERY[area] : 0;
    return {
      count: count,
      subtotal: subtotal,
      combo: total,
      /* Never negative: subtotal is the sum of the real variant prices and
         comboTotal is the discounted figure, so this IS the discount. */
      saving: Math.max(0, subtotal - total),
      ship: ship,
      payable: total + ship
    };
  }

  /* ── State ─────────────────────────────────────────────────────────────── */
  var slots = [];
  for (var s0 = 0; s0 < SLOTS; s0++) slots.push(null);
  var area = 'inside';
  /* How many packs the visitor said they want, set from the price-ladder cards.
     It only governs whether the picker keeps chaining to the next slot — every
     slot stays fillable, so nobody is ever blocked from taking more. */
  var target = SLOTS;
  var otherCartItems = 0;

  /* ── Element refs ──────────────────────────────────────────────────────── */
  var el = {
    slots: root.querySelector('[data-slots]'),
    prog: root.querySelector('[data-prog]'),
    nudge: root.querySelector('[data-nudge]'),
    nudgeText: root.querySelector('[data-nudge-text]'),
    sumLines: root.querySelector('[data-sum-lines]'),
    sumCount: root.querySelector('[data-sum-count]'),
    rowSub: root.querySelector('[data-row-sub]'),
    rowSave: root.querySelector('[data-row-save]'),
    rowSaveWrap: root.querySelector('[data-row-save-wrap]'),
    rowShip: root.querySelector('[data-row-ship]'),
    total: root.querySelector('[data-total]'),
    cta: root.querySelector('[data-cta]'),
    ctaLabel: root.querySelector('[data-cta-label]'),
    msg: root.querySelector('[data-msg]'),
    dock: root.querySelector('[data-dock]'),
    dockV: root.querySelector('[data-dock-v]'),
    dockWas: root.querySelector('[data-dock-was]'),
    dockCta: root.querySelector('[data-dock-cta]'),
    dockCtaLabel: root.querySelector('[data-dock-cta-label]'),
    pick: root.querySelector('[data-pick]'),
    pickBody: root.querySelector('[data-pick-body]'),
    pickTitle: root.querySelector('[data-pick-title]'),
    pickStep: root.querySelector('[data-pick-step]'),
    toast: root.querySelector('[data-toast]'),
    fcart: root.querySelector('[data-fcart]'),
    fcartDots: root.querySelector('[data-fcart-dots]'),
    fcartK: root.querySelector('[data-fcart-k]'),
    fcartV: root.querySelector('[data-fcart-v]'),
    fcartSave: root.querySelector('[data-fcart-save]'),
    details: root.querySelector('[data-details]')
  };

  /* ── Slots ─────────────────────────────────────────────────────────────── */
  function styleAt(i) {
    return STYLES[i];
  }

  function slotIsFree(index) {
    return freeSlotIndex() === index;
  }

  function renderSlots() {
    if (!el.slots) return;
    var out = '';
    for (var i = 0; i < SLOTS; i++) {
      var pick = slots[i];
      var n = i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
      var isLast = i === SLOTS - 1;

      if (!pick) {
        out +=
          '<button type="button" class="tlx-slot' +
          (isLast ? ' tlx-slot--free' : '') +
          '" data-slot="' +
          i +
          '">' +
          '<span class="tlx-slot__n">' +
          digits(n) +
          '</span>' +
          '<span class="tlx-slot__body">' +
          '<span class="tlx-slot__plus" aria-hidden="true">+</span>' +
          '<span class="tlx-slot__hint">' +
          (isLast ? T('build.slotFree') : T('build.slotEmpty')) +
          '</span>' +
          '</span>' +
          '</button>';
        continue;
      }

      var st = styleAt(pick.styleIdx);
      var freeTag = slotIsFree(i)
        ? '<span class="tlx-slot__tag tlx-slot__tag--free">' + T('build.free') + '</span>'
        : '<span class="tlx-slot__tag">' + digits(n) + '</span>';

      out +=
        '<div class="tlx-slot" data-filled="true" data-slot="' +
        i +
        '" role="button" tabindex="0">' +
        '<div class="tlx-slot__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="300" height="300">' +
        freeTag +
        '<button type="button" class="tlx-slot__x" data-clear="' +
        i +
        '" aria-label="' +
        esc(T('build.remove')) +
        '">&times;</button>' +
        '</div>' +
        '<div class="tlx-slot__meta">' +
        '<span class="tlx-slot__name">' +
        esc(st.name) +
        '</span>' +
        '<span class="tlx-slot__size">' +
        esc(st.kicker) +
        ' · ' +
        esc(pick.size) +
        '</span>' +
        '</div>' +
        '</div>';
    }
    el.slots.innerHTML = out;
  }

  function renderProg() {
    if (!el.prog) return;
    var segs = el.prog.querySelectorAll('.tlx-prog__seg');
    for (var i = 0; i < segs.length; i++) {
      segs[i].setAttribute('data-on', slots[i] ? 'true' : 'false');
    }
  }

  function renderTiers() {
    var tiers = root.querySelectorAll('[data-tier]');
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].setAttribute(
        'aria-pressed',
        Number(tiers[i].getAttribute('data-tier')) === target ? 'true' : 'false'
      );
    }
  }

  /* What the LAST pack actually adds to the bill, and the saving once the combo
     is complete — both read off LADDER, never hard-coded. With Buy 3 Get 1 Free
     at a flat unit price the step is 0, which is exactly the fact the page is
     built to sell; if the discount is ever changed these two numbers follow it
     instead of quietly going stale. */
  function lastStep() {
    return Math.max(0, comboTotal(SLOTS) - comboTotal(SLOTS - 1));
  }

  function fullSaving() {
    return Math.max(0, UNIT * SLOTS - comboTotal(SLOTS));
  }

  function renderNudge() {
    if (!el.nudge || !el.nudgeText) return;
    var p = priceState();
    /* Hit the chosen tier below a full combo? Say so, rather than nagging on. */
    if (p.count > 0 && p.count === target && target < SLOTS) {
      el.nudgeText.innerHTML =
        T('build.ready').replace('{n}', digits(p.count)).replace('{p}', money(p.combo));
      el.nudge.setAttribute('data-hot', 'done');
      return;
    }

    var key;
    if (p.count <= 0) key = 'build.nudge0';
    else if (p.count >= SLOTS) key = 'build.nudgeDone';
    else if (p.count === SLOTS - 1) {
      key = lastStep() > 0 ? 'build.nudgeLastPaid' : 'build.nudgeLastFree';
    } else key = 'build.nudgeMore';

    el.nudgeText.innerHTML = T(key)
      .replace('{u}', money(UNIT))
      .replace('{n}', digits(p.count + 1))
      .replace('{t}', digits(SLOTS))
      .replace('{next}', money(comboTotal(Math.min(p.count + 1, SLOTS))))
      .replace('{step}', money(lastStep()))
      .replace('{save}', money(fullSaving()));

    el.nudge.setAttribute(
      'data-hot',
      p.count === SLOTS ? 'done' : p.count === SLOTS - 1 ? 'true' : 'false'
    );
  }

  function renderSummary() {
    var p = priceState();

    if (el.sumCount) {
      el.sumCount.textContent = digits(p.count) + ' / ' + digits(SLOTS) + ' ' + T('sum.count');
    }

    if (el.sumLines) {
      if (!p.count) {
        el.sumLines.innerHTML =
          '<p class="tlx-sum__empty">' + esc(T('sum.empty')) + '</p>';
      } else {
        var out = '';
        for (var i = 0; i < SLOTS; i++) {
          if (!slots[i]) continue;
          var st = styleAt(slots[i].styleIdx);
          var free = slotIsFree(i);
          out +=
            '<div class="tlx-sum__line' +
            (free ? ' tlx-sum__line--free' : '') +
            '">' +
            '<span class="tlx-cw tlx-cw--sm" style="' +
            cwStyle(st) +
            '"></span>' +
            '<span class="tlx-sum__line-n">' +
            esc(st.name) +
            ' · ' +
            esc(slots[i].size) +
            '</span>' +
            '<span class="tlx-sum__line-p">' +
            (free ? T('build.free') : money(slots[i].price != null ? slots[i].price : UNIT)) +
            '</span>' +
            '</div>';
        }
        el.sumLines.innerHTML = out;
      }
    }

    if (el.rowSub) el.rowSub.textContent = money(p.subtotal);
    if (el.rowSave) el.rowSave.textContent = '− ' + money(p.saving);
    if (el.rowSaveWrap) el.rowSaveWrap.hidden = p.saving <= 0;
    if (el.rowShip) el.rowShip.textContent = p.count ? money(p.ship) : '—';
    if (el.total) el.total.textContent = money(p.payable);

    var ready = p.count === SLOTS;
    var any = p.count > 0;
    if (el.cta) el.cta.disabled = !any;
    if (el.ctaLabel) {
      el.ctaLabel.textContent = !any
        ? T('sum.ctaWait')
        : el.details && el.details.hidden
        ? T('sum.ctaDetails')
        : T('sum.cta');
    }

    if (el.dockV) el.dockV.textContent = money(p.payable);
    if (el.dockWas) {
      el.dockWas.textContent = p.saving > 0 ? money(p.subtotal + p.ship) : '';
      el.dockWas.hidden = p.saving <= 0;
    }
    if (el.dockCta) el.dockCta.disabled = false;
    if (el.dockCtaLabel) {
      el.dockCtaLabel.textContent = any ? T('dock.cta') : T('dock.pick');
    }

    if (el.msg && el.msg.getAttribute('data-kind') !== 'error') {
      el.msg.textContent =
        otherCartItems > 0
          ? T('sum.cartHas').replace('{n}', digits(otherCartItems))
          : '';
    }

    if (ready && !reduceMotion) burst();
  }

  /* Floating tracker: progress dots, running total, and the saving once one
     exists. At a full combo it turns into the checkout button rather than a
     second "go to the builder" link, since the builder's work is done. */
  function renderFloatCart() {
    if (!el.fcart) return;
    var p = priceState();

    if (el.fcartDots && el.fcartDots.children.length !== SLOTS) {
      var html = '';
      for (var i = 0; i < SLOTS; i++) html += '<span class="tlx-fcart__dot"></span>';
      el.fcartDots.innerHTML = html;
    }
    if (el.fcartDots) {
      for (var j = 0; j < el.fcartDots.children.length; j++) {
        el.fcartDots.children[j].setAttribute('data-on', slots[j] ? 'true' : 'false');
      }
    }

    var ready = p.count === SLOTS;
    el.fcart.setAttribute('data-state', ready ? 'ready' : p.count ? 'building' : 'empty');
    if (el.fcartK) {
      el.fcartK.textContent = !p.count
        ? T('fcart.empty')
        : ready
        ? T('fcart.ready')
        : T('fcart.of').replace('{n}', digits(p.count)).replace('{t}', digits(SLOTS));
    }
    if (el.fcartV) el.fcartV.textContent = money(p.payable);
    if (el.fcartSave) {
      el.fcartSave.hidden = p.saving <= 0;
      el.fcartSave.textContent = T('fcart.save').replace('{p}', money(p.saving));
    }
  }

  function render() {
    renderTiers();
    renderSlots();
    renderProg();
    renderNudge();
    renderSummary();
    renderFloatCart();
  }

  /* ── Picker ────────────────────────────────────────────────────────────── */
  var pickSlot = -1;

  function cwStyle(st) {
    var a = st.cw && st.cw[0] ? st.cw[0] : '#16171a';
    var b = st.cw && st.cw[1] ? st.cw[1] : a;
    return '--cw-a:' + a + ';--cw-b:' + b;
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openPicker(index) {
    pickSlot = index;
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'true');
    /* iOS Safari ignores overflow:hidden on <html> alone. */
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    renderPickStyles();
  }

  function closePicker() {
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    pickSlot = -1;
  }

  function stockLeft(st) {
    var n = 0;
    for (var i = 0; i < st.variants.length; i++) {
      if (st.variants[i].ok) n += Math.max(0, st.variants[i].qty);
    }
    return n;
  }

  /* How many of this exact variant the builder has already claimed, so we can
     stop someone reserving 3 of a size that only has 2 in stock. */
  function claimed(variantId, ignoreSlot) {
    var n = 0;
    for (var i = 0; i < slots.length; i++) {
      if (i === ignoreSlot) continue;
      if (slots[i] && slots[i].variantId === variantId) n++;
    }
    return n;
  }

  function renderPickStyles() {
    if (!el.pickBody) return;
    el.pick.setAttribute('data-step', '1');
    if (el.pickTitle) el.pickTitle.textContent = T('pick.h1');
    if (el.pickStep) {
      el.pickStep.textContent =
        T('pick.step1') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var out = '<div class="tlx-pgrid">';
    for (var i = 0; i < STYLES.length; i++) {
      var st = STYLES[i];
      var left = stockLeft(st);
      var out_ = left <= 0;
      out +=
        '<button type="button" class="tlx-pcard" data-style="' +
        i +
        '"' +
        (out_ ? ' data-out="true" disabled' : '') +
        '>' +
        '<span class="tlx-pcard__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="360" height="450">' +
        (out_
          ? '<span class="tlx-pcard__low">' + esc(T('pick.out')) + '</span>'
          : left <= 3
          ? '<span class="tlx-pcard__low">' +
            esc(T('pick.low').replace('{n}', digits(left))) +
            '</span>'
          : '') +
        '</span>' +
        '<span class="tlx-pcard__meta">' +
        '<span class="tlx-pcard__cw">' +
        '<span class="tlx-cw" style="' +
        cwStyle(st) +
        '"></span>' +
        '<span class="tlx-pcard__name">' +
        esc(st.name) +
        '</span>' +
        '</span>' +
        '<span class="tlx-pcard__series">' +
        esc(st.kicker) +
        '</span>' +
        '</span>' +
        '</button>';
    }
    out += '</div>';
    el.pickBody.innerHTML = out;
    el.pickBody.scrollTop = 0;
  }

  function renderPickSizes(styleIdx) {
    if (!el.pickBody) return;
    var st = STYLES[styleIdx];
    el.pick.setAttribute('data-step', '2');
    var backBtn = el.pick.querySelector('.tlx-pick__back');
    if (backBtn) backBtn.setAttribute('aria-label', T('pick.back'));
    if (el.pickTitle) el.pickTitle.textContent = T('pick.h2');
    if (el.pickStep) {
      el.pickStep.textContent =
        T('pick.step2') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var chips = '';
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      var free = Math.max(0, v.qty - claimed(v.id, pickSlot));
      var can = v.ok && free > 0;
      chips +=
        '<button type="button" class="tlx-size" data-variant="' +
        v.id +
        '" data-size="' +
        esc(v.size) +
        '" data-style="' +
        styleIdx +
        '" data-price="' +
        (v.price != null ? v.price : UNIT) +
        '"' +
        (can ? '' : ' disabled') +
        '>' +
        esc(v.size) +
        (can && free <= 3
          ? '<small>' + esc(digits(free) + ' ' + T('pick.left')) + '</small>'
          : '') +
        '</button>';
    }

    /* The chart is scoped to the sizes THIS pack offers, and sold-out rows are
       struck through to match the chips above — a chart listing sizes you cannot
       pick would be worse than no chart. Open by default where there is room;
       collapsed on a phone so it never buries the size buttons. */
    var offered = {};
    for (var v = 0; v < st.variants.length; v++) {
      offered[st.variants[v].size] = st.variants[v];
    }
    var rows = '';
    for (var c = 0; c < SIZE_CHART.length; c++) {
      var row = SIZE_CHART[c];
      var variant = offered[row.size];
      if (!variant) continue;
      var out = !(variant.ok && Math.max(0, variant.qty - claimed(variant.id, pickSlot)) > 0);
      rows +=
        '<tr' + (out ? ' data-out="true"' : '') + '>' +
        '<th scope="row">' + esc(row.size) + '</th>' +
        '<td>' + esc(digits(row.waist)) + '</td>' +
        '<td>' + esc(digits(row.waistCm)) + '</td>' +
        '</tr>';
    }
    var chart = !rows ? '' :
      '<details class="tlx-chart"' + (window.innerWidth >= 620 ? ' open' : '') + '>' +
      '<summary><span>' + esc(T('pick.chart')) + '</span>' +
      '<small>' + esc(T('pick.chartHint')) + '</small>' +
      '<span class="tlx-chart__pm" aria-hidden="true"></span></summary>' +
      '<div class="tlx-chart__scroll"><table class="tlx-chart__table"><thead><tr>' +
      '<th>' + esc(T('size.thSize')) + '</th>' +
      '<th>' + esc(T('size.thWaist')) + '</th>' +
      '<th>' + esc(T('size.thWaistCm')) + '</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<p class="tlx-chart__note">' + esc(T('size.note')) + '</p>' +
      '</details>';

    el.pickBody.innerHTML =
      '<div class="tlx-psize">' +
      '<div class="tlx-psize__pic"><img src="' +
      st.img +
      '" alt="' +
      esc(st.title) +
      '" width="420" height="525"></div>' +
      '<div>' +
      '<div class="tlx-pcard__cw" style="margin-bottom:10px">' +
      '<span class="tlx-cw tlx-cw--lg" style="' +
      cwStyle(st) +
      '"></span>' +
      '<span class="tlx-pcard__series">' +
      esc(st.kicker) +
      '</span>' +
      '</div>' +
      '<h4 class="tlx-head tlx-psize__name">' +
      esc(st.name) +
      '</h4>' +
      '<p class="tlx-psize__k">' +
      esc(st.title) +
      '</p>' +
      '<div class="tlx-sizes">' +
      chips +
      '</div>' +
      chart +
      '</div>' +
      '</div>';
    el.pickBody.scrollTop = 0;
  }

  /* ── Cart ──────────────────────────────────────────────────────────────── */
  function aggregate() {
    var map = {};
    var order = [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i]) continue;
      var id = slots[i].variantId;
      if (map[id] == null) {
        map[id] = 0;
        order.push(id);
      }
      map[id]++;
    }
    var items = [];
    for (var j = 0; j < order.length; j++) {
      items.push({ id: Number(order[j]), quantity: map[order[j]] });
    }
    return items;
  }

  function setMsg(text, kind) {
    if (!el.msg) return;
    el.msg.textContent = text || '';
    if (kind) el.msg.setAttribute('data-kind', kind);
    else el.msg.removeAttribute('data-kind');
  }

  function toast(text) {
    if (!el.toast) return;
    el.toast.textContent = text;
    el.toast.setAttribute('data-show', 'true');
    window.setTimeout(function () {
      el.toast.setAttribute('data-show', 'false');
    }, 2400);
  }


  /* ── On-page details → pre-filled Shopify checkout ──────────────────────
     A theme cannot create an order, so the hand-off goes through a cart
     permalink: /cart/{variant}:{qty},...?checkout[...]=... . A permalink also
     REPLACES the cart rather than adding to it, which conveniently rules out a
     stale cart contaminating the combo total. Verified on this store that
     email, first/last name, address1, city, postalCode and phone all pre-fill,
     and the automatic combo discount still applies. */
  function detField(name) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    return elx ? String(elx.value || '').trim() : '';
  }

  function setFieldError(name, msg) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    if (!elx) return;
    elx.setAttribute('data-invalid', msg ? 'true' : 'false');
    var holder = elx.parentNode;
    var err = holder.querySelector('.tlx-field__err');
    if (msg) {
      if (!err) {
        err = document.createElement('span');
        err.className = 'tlx-field__err';
        holder.appendChild(err);
      }
      err.textContent = msg;
    } else if (err) {
      err.parentNode.removeChild(err);
    }
  }

  /* Bangladeshi mobile numbers: 11 digits starting 01, optionally +880/880. */
  function normalizeBdPhone(raw) {
    var d = String(raw || '').replace(/[^0-9]/g, '');
    if (d.indexOf('880') === 0) d = d.slice(3);
    if (d.length === 10 && d.indexOf('1') === 0) d = '0' + d;
    return /^01[3-9][0-9]{8}$/.test(d) ? d : '';
  }

  function validateDetails() {
    var ok = true;
    var name = detField('name');
    var phone = normalizeBdPhone(detField('phone'));
    var addr = detField('address');
    var city = detField('city');
    setFieldError('name', name.length >= 2 ? '' : T('det.errName'));
    if (name.length < 2) ok = false;
    setFieldError('phone', phone ? '' : T('det.errPhone'));
    if (!phone) ok = false;
    setFieldError('address', addr.length >= 6 ? '' : T('det.errAddress'));
    if (addr.length < 6) ok = false;
    setFieldError('city', city.length >= 2 ? '' : T('det.errCity'));
    if (city.length < 2) ok = false;
    if (!ok) {
      var firstBad = root.querySelector('[data-det][data-invalid="true"]');
      if (firstBad) {
        firstBad.focus();
        firstBad.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }
    return ok ? { name: name, phone: phone, addr: addr, city: city, email: detField('email') } : null;
  }

  function checkoutPermalink(d) {
    var items = aggregate();
    if (!items.length) return '';
    var parts = [];
    for (var i = 0; i < items.length; i++) parts.push(items[i].id + ':' + items[i].quantity);
    var bits = String(d.name || '').split(' ');
    var q = [];
    var add = function (k, v) {
      if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    };
    var sp = 'checkout[shipping_address]';
    add('checkout[email]', d.email);
    add(sp + '[first_name]', bits[0] || d.name);
    add(sp + '[last_name]', bits.slice(1).join(' ') || '.');
    add(sp + '[address1]', d.addr);
    add(sp + '[city]', d.city);
    add(sp + '[country]', 'Bangladesh');
    add(sp + '[phone]', d.phone);
    /* Carried onto the order so packing slips and Pathao labels show the combo. */
    /* Carried onto the order so the packing slip says what was actually sold:
       slots, not line items — two slots holding the same size aggregate into
       one line, so items.length would under-report the combo. */
    var packs = 0;
    for (var s = 0; s < slots.length; s++) if (slots[s]) packs++;
    add(
      'attributes[Combo]',
      digits(String(packs)) + ' packs (' + digits(String(packs * PER_PACK)) + ' boxers)'
    );
    add('attributes[Delivery area]', area === 'outside' ? 'Outside Dhaka' : 'Inside Dhaka');
    return '/cart/' + parts.join(',') + (q.length ? '?' + q.join('&') : '');
  }

  var busy = false;

  function checkout() {
    var items = aggregate();
    if (!items.length) {
      scrollToId('offer');
      return;
    }
    if (busy) return;

    /* Details are required before the hand-off, so the buyer never lands on an
       empty checkout form having already "finished" on this page. */
    if (el.details) {
      if (el.details.hidden) {
        el.details.hidden = false;
        renderSummary();
        var firstIn = el.details.querySelector('[data-det]');
        if (firstIn) {
          el.details.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          window.setTimeout(function () { firstIn.focus(); }, reduceMotion ? 0 : 420);
        }
        return;
      }
      var d = validateDetails();
      if (!d) return;
      busy = true;
      if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
      setMsg('');
      window.location.href = checkoutPermalink(d);
      return;
    }
    busy = true;
    if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
    if (el.cta) el.cta.disabled = true;
    setMsg('');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          })
          .catch(function () {
            return { ok: r.ok, status: r.status, body: null };
          });
      })
      .then(function (res) {
        if (!res.ok) {
          var desc = res.body && (res.body.description || res.body.message);
          setMsg(res.status === 422 ? T('sum.errStock') : desc || T('sum.err'), 'error');
          busy = false;
          if (el.cta) el.cta.disabled = false;
          renderSummary();
          return;
        }
        toast(T('toast.added'));
        window.location.href = '/checkout';
      })
      .catch(function () {
        setMsg(T('sum.err'), 'error');
        busy = false;
        if (el.cta) el.cta.disabled = false;
        renderSummary();
      });
  }

  function readCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        otherCartItems = c && c.item_count ? c.item_count : 0;
        renderSummary();
      })
      .catch(function () {});
  }

  /* ── Flourish: a short confetti burst the first time all four land ─────── */
  var bursted = false;

  function burst() {
    if (bursted || reduceMotion) return;
    bursted = true;
    var host = el.nudge;
    if (!host) return;
    var colours = ['#b98b33', '#d3a445', '#59663a', '#f4f2ea'];
    for (var i = 0; i < 16; i++) {
      var bit = document.createElement('span');
      var ang = (Math.PI * 2 * i) / 16;
      bit.style.cssText =
        'position:absolute;left:50%;top:50%;width:6px;height:6px;pointer-events:none;' +
        'border-radius:1px;background:' +
        colours[i % colours.length] +
        ';transform:translate(-50%,-50%);opacity:1;transition:transform .9s cubic-bezier(.2,.7,.3,1),opacity .9s ease';
      host.style.position = 'relative';
      host.appendChild(bit);
      (function (node, angle) {
        window.setTimeout(function () {
          var d = 60 + Math.random() * 70;
          node.style.transform =
            'translate(' +
            (Math.cos(angle) * d - 3) +
            'px,' +
            (Math.sin(angle) * d - 3) +
            'px) rotate(' +
            Math.random() * 320 +
            'deg)';
          node.style.opacity = '0';
        }, 20);
        window.setTimeout(function () {
          if (node.parentNode) node.parentNode.removeChild(node);
        }, 1100);
      })(bit, ang);
    }
  }

  /* ── Hero pack swap ─────────────────────────────────────────────────────
     The swatch rail under the hero photo reads as a control, so it is one: tap
     a pack and the photo becomes that pack. The new source is preloaded before
     the swap so the frame never flashes empty on a slow connection. */
  function setHero(index) {
    var st = STYLES[index];
    if (!st) return;

    var img = root.querySelector('[data-hero-img]');
    var label = root.querySelector('[data-hero-label]');
    var swatches = root.querySelectorAll('[data-hero]');

    for (var i = 0; i < swatches.length; i++) {
      swatches[i].setAttribute(
        'data-active',
        Number(swatches[i].getAttribute('data-hero')) === index ? 'true' : 'false'
      );
    }

    if (label) {
      label.removeAttribute('data-i18n');
      label.textContent = (st.kicker + ' · ' + st.name).toUpperCase();
    }

    if (!img) return;
    var large = st.imgLg || st.img;
    /* Preload the size this viewport will actually pick from the srcset — the
       900w file is pure waste on a phone, and this audience pays for its data. */
    var wide = window.innerWidth >= 940;
    var pre = new Image();
    pre.onload = function () {
      img.src = large;
      img.srcset = st.img + ' 520w, ' + large + ' 900w';
      img.alt = st.title;
      img.style.opacity = '';
    };
    pre.onerror = function () {
      img.style.opacity = '';
    };
    if (!reduceMotion) img.style.opacity = '0.35';
    pre.src = wide ? large : st.img;
  }

  /* ── Hero autoplay ──────────────────────────────────────────────────────
     Cycles the hero through the packs so a visitor who never touches the rail
     still sees the range. Three stop conditions, all deliberate:
       · the visitor taps a swatch — they have taken control, so we stay out
       · the hero scrolls out of view — no point burning data or battery
       · prefers-reduced-motion, or the merchant set a fixed hero image
     Nothing is prefetched ahead of time; each step preloads only its own frame. */
  var autoTimer = null;
  var autoIndex = 0;
  var autoStopped = false;

  function autoStop() {
    autoStopped = true;
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function autoStart() {
    if (autoStopped || autoTimer || STYLES.length < 2) return;
    autoTimer = window.setInterval(function () {
      autoIndex = (autoIndex + 1) % STYLES.length;
      setHero(autoIndex);
    }, AUTOPLAY_MS);
  }

  function autoPause() {
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function setupAutoplay() {
    if (!AUTOPLAY || reduceMotion) return;
    var frame = root.querySelector('.tlx-hero__frame');
    /* No initially-active swatch means the merchant pinned a custom hero image;
       cycling would override their choice. */
    var active = root.querySelector('[data-hero][data-active="true"]');
    if (!frame || !active) return;
    autoIndex = Number(active.getAttribute('data-hero')) || 0;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) autoStart();
            else autoPause();
          }
        },
        { threshold: 0.25 }
      );
      io.observe(frame);
    } else {
      autoStart();
    }

    /* Hovering to read the markers should not fight the rotation. */
    frame.addEventListener('mouseenter', autoPause);
    frame.addEventListener('mouseleave', function () {
      if (!autoStopped) autoStart();
    });
  }

  /* ── Scroll choreography ───────────────────────────────────────────────── */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function setupReveal() {
    var items = root.querySelectorAll('.tlx-rv');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].setAttribute('data-in', 'true');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.setAttribute('data-in', 'true');
            io.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function setupNav() {
    var nav = root.querySelector('[data-nav]');
    var spineNow = root.querySelector('[data-spine-now]');
    var sections = root.querySelectorAll('[data-sec-label]');
    var links = root.querySelectorAll('[data-nav-link]');

    /* Which section is current is tracked by IntersectionObserver, NOT by
       measuring every section on each scroll frame. The old version called
       getBoundingClientRect() on all five sections inside the rAF, forcing a
       synchronous layout on every frame of every scroll — the main reason this
       page felt like it was dragging. The scroll handler below now reads only
       pageYOffset, which costs nothing. */
    function markCurrent(id) {
      var label = '';
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].id === id) label = sections[i].getAttribute('data-sec-label');
      }
      if (spineNow && label) spineNow.textContent = label;
      for (var j = 0; j < links.length; j++) {
        links[j].setAttribute(
          'aria-current',
          links[j].getAttribute('data-nav-link') === id ? 'true' : 'false'
        );
      }
    }

    if ('IntersectionObserver' in window && sections.length) {
      var seen = {};
      var secObs = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            seen[entries[i].target.id] = entries[i].isIntersecting;
          }
          /* Topmost section still in the upper band wins. */
          for (var k = sections.length - 1; k >= 0; k--) {
            if (seen[sections[k].id]) {
              markCurrent(sections[k].id);
              return;
            }
          }
        },
        { rootMargin: '-14% 0px -70% 0px' }
      );
      for (var s2 = 0; s2 < sections.length; s2++) secObs.observe(sections[s2]);
    }

    /* Pause the always-on animations while the hero is off screen. */
    var hero = document.getElementById('top');
    if ('IntersectionObserver' in window && hero) {
      var animObs = new IntersectionObserver(
        function (entries) {
          root.setAttribute('data-anim-paused', entries[0].isIntersecting ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      animObs.observe(hero);
    }

    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (nav) nav.setAttribute('data-stuck', y > 12 ? 'true' : 'false');
      if (el.dock) el.dock.setAttribute('data-show', y > 420 ? 'true' : 'false');
      if (el.fcart) el.fcart.setAttribute('data-show', y > 420 ? 'true' : 'false');
    };

    var raf = false;
    window.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = true;
        window.requestAnimationFrame(function () {
          raf = false;
          onScroll();
        });
      },
      { passive: true }
    );
    onScroll();
  }

  /* ── Theme ─────────────────────────────────────────────────────────────── */
  function setTheme(next) {
    document.documentElement.setAttribute('data-theme', next);
    try {
      localStorage.setItem('tlx-theme', next);
    } catch (e) {}
  }

  function currentTheme() {
    var attr = document.documentElement.getAttribute('data-theme');
    if (attr === 'dark' || attr === 'light') return attr;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }

  /* ── Events ────────────────────────────────────────────────────────────── */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    /* × is nested inside the slot card, so it must be tested first. */
    var clearBtn = t.closest('[data-clear]');
    if (clearBtn) {
      slots[Number(clearBtn.getAttribute('data-clear'))] = null;
      bursted = false;
      render();
      toast(T('toast.removed'));
      return;
    }

    var slotBtn = t.closest('[data-slot]');
    if (slotBtn) {
      openPicker(Number(slotBtn.getAttribute('data-slot')));
      return;
    }

    var styleBtn = t.closest('[data-style]:not([data-variant])');
    if (styleBtn && el.pick && el.pick.getAttribute('data-open') === 'true') {
      renderPickSizes(Number(styleBtn.getAttribute('data-style')));
      return;
    }

    var sizeBtn = t.closest('[data-variant]');
    if (sizeBtn && !sizeBtn.disabled) {
      var idx = pickSlot;
      if (idx < 0) return;
      slots[idx] = {
        styleIdx: Number(sizeBtn.getAttribute('data-style')),
        variantId: Number(sizeBtn.getAttribute('data-variant')),
        size: sizeBtn.getAttribute('data-size'),
        price: Number(sizeBtn.getAttribute('data-price')) || UNIT
      };
      closePicker();
      render();
      /* Chain into the next empty slot so filling the goal is one flow — but
         stop once the visitor's chosen tier is reached. */
      var filled = 0;
      for (var f = 0; f < slots.length; f++) if (slots[f]) filled++;
      var next = -1;
      if (filled < target) {
        for (var i = 0; i < slots.length; i++) {
          if (!slots[i]) {
            next = i;
            break;
          }
        }
      }
      if (next > -1) {
        window.setTimeout(function () {
          openPicker(next);
        }, 260);
      }
      return;
    }

    if (t.closest('[data-pick-back]')) {
      renderPickStyles();
      return;
    }

    if (t.closest('[data-pick-close]') || t.closest('.tlx-pick__veil')) {
      closePicker();
      return;
    }

    var tierBtn = t.closest('[data-tier]');
    if (tierBtn) {
      target = Number(tierBtn.getAttribute('data-tier')) || SLOTS;
      renderTiers();
      renderNudge();
      scrollToId('offer');
      var open1 = -1;
      for (var q = 0; q < slots.length; q++) {
        if (!slots[q]) {
          open1 = q;
          break;
        }
      }
      if (open1 > -1) {
        window.setTimeout(function () {
          openPicker(open1);
        }, reduceMotion ? 60 : 620);
      }
      return;
    }

    var heroSw = t.closest('[data-hero]');
    if (heroSw) {
      autoStop();
      setHero(Number(heroSw.getAttribute('data-hero')));
      return;
    }

    /* Gallery card → build the combo here instead of navigating away. Modifier
       and middle clicks are left alone so "open in new tab" still works, and the
       href stays intact for crawlers and for a JS-less visitor. */
    var galCard = t.closest('[data-gal]');
    if (galCard && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey && !ev.altKey && ev.button === 0) {
      ev.preventDefault();
      var styleIdx = Number(galCard.getAttribute('data-gal'));

      /* Never open a picker with nothing pickable in it. Counts what the other
         slots have already reserved, so the last unit cannot be double-claimed. */
      var st0 = STYLES[styleIdx];
      var pickable = 0;
      if (st0) {
        for (var v0 = 0; v0 < st0.variants.length; v0++) {
          var vv0 = st0.variants[v0];
          if (vv0.ok && Math.max(0, vv0.qty - claimed(vv0.id, -1)) > 0) pickable++;
        }
      }
      if (!pickable) {
        toast(T('toast.soldout'));
        return;
      }

      var slot = -1;
      for (var g = 0; g < slots.length; g++) {
        if (!slots[g]) {
          slot = g;
          break;
        }
      }
      if (slot < 0) {
        /* Nothing silently replaced — tell them what to do instead. */
        toast(T('toast.full'));
        scrollToId('offer');
        return;
      }
      scrollToId('offer');
      window.setTimeout(function () {
        pickSlot = slot;
        el.pick.setAttribute('data-open', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        /* Straight to step 2 — they already chose the pack by clicking it. */
        renderPickSizes(styleIdx);
      }, reduceMotion ? 60 : 520);
      return;
    }

    var langBtn = t.closest('[data-lang-btn]');
    if (langBtn) {
      setLang(langBtn.getAttribute('data-lang-btn'));
      return;
    }

    if (t.closest('[data-theme-toggle]')) {
      setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      return;
    }

    if (t.closest('[data-cta]') || t.closest('[data-dock-cta]')) {
      checkout();
      return;
    }

    if (t.closest('[data-fcart]')) {
      var fp = priceState();
      if (fp.count === SLOTS) checkout();
      else scrollToId('offer');
      return;
    }

    var jump = t.closest('[data-jump]');
    if (jump) {
      ev.preventDefault();
      scrollToId(jump.getAttribute('data-jump'));
      return;
    }
  });

  root.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.name === 'tlx-area') {
      area = t.value === 'outside' ? 'outside' : 'inside';
      renderSummary();
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && el.pick && el.pick.getAttribute('data-open') === 'true') {
      closePicker();
      return;
    }
    /* Filled slots are divs with role=button, so Enter/Space need wiring. */
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var focused = document.activeElement;
    if (!focused || !focused.getAttribute) return;
    if (focused.getAttribute('data-filled') === 'true') {
      ev.preventDefault();
      openPicker(Number(focused.getAttribute('data-slot')));
    }
  });

  /* ── Boot ──────────────────────────────────────────────────────────────── */
  readEnglish();
  for (var seedKey in EN_JS) {
    if (Object.prototype.hasOwnProperty.call(EN_JS, seedKey) && EN[seedKey] == null) {
      EN[seedKey] = EN_JS[seedKey];
    }
  }

  var savedLang;
  var savedTheme;
  try {
    savedLang = localStorage.getItem('tlx-lang');
    savedTheme = localStorage.getItem('tlx-theme');
  } catch (e) {}
  if (savedTheme === 'dark' || savedTheme === 'light') {
    document.documentElement.setAttribute('data-theme', savedTheme);
  }
  setLang(savedLang === 'bn' ? 'bn' : 'en');

  setupReveal();
  setupNav();
  setupAutoplay();
  readCart();
})();
